export var operators = [{
        label: 'Operator 1',
        tasks: [{
                id: 1,
                duration: 8,
                label: 'Documentation',
                topColor: '#D8E0E6',
                sideColor: '#ADC0D0',
                frontColor: '#C1CFDA'
            }, {
                id: 2,
                duration: 15,
                label: 'Packaging',
                topColor: '#D8E0E6',
                sideColor: '#ADC0D0',
                frontColor: '#C1CFDA'
            }, {
                id: 3,
                duration: 30,
                label: 'Quality Inspection',
                labelColor: '#ffffff',
                topColor: '#F27E73',
                sideColor: '#DB063B',
                frontColor: '#ED2637'
            }, {
                id: 4,
                duration: 12,
                label: 'Assembling Components',
                topColor: '#CCC',
                sideColor: '#A29F9F',
                frontColor: '#AAA'
            }]
    }, {
        label: 'Operator 2',
        tasks: [{
                id: 5,
                duration: 20,
                label: 'Cleanup and Maintenance',
                topColor: '#E9B9B9',
                sideColor: '#E08597',
                frontColor: '#E5989B'
            }, {
                id: 6,
                duration: 12,
                label: 'Final Assembly',
                topColor: '#D8E0E6',
                sideColor: '#ADC0D0',
                frontColor: '#C1CFDA'
            }, {
                id: 7,
                duration: 5,
                label: 'Testing and Calibration',
                topColor: '#D8E0E6',
                sideColor: '#ADC0D0',
                frontColor: '#C1CFDA'
            }, {
                id: 8,
                duration: 20,
                label: 'Wiring and Connections',
                topColor: '#B4D8F1',
                sideColor: '#7AB9E8',
                frontColor: '#98C8ED'
            }]
    }, {
        label: 'Operator 3',
        tasks: [{
                id: 9,
                duration: 20,
                label: 'Tool and Equipment Setup',
                labelColor: '#ffffff',
                topColor: '#2869A9',
                sideColor: '#174A6E',
                frontColor: '#1E5081'
            }, {
                id: 10,
                duration: 10,
                label: 'Component Alignments',
                topColor: '#D8E0E6',
                sideColor: '#ADC0D0',
                frontColor: '#C1CFDA'
            }, {
                id: 11,
                duration: 8,
                label: 'Precision measurements',
                topColor: '#D8E0E6',
                sideColor: '#ADC0D0',
                frontColor: '#C1CFDA'
            }, {
                id: 12,
                duration: 12,
                label: 'Surface Finishing',
                topColor: '#F0C195',
                sideColor: '#D8A16D',
                frontColor: '#F7A457'
            }]
    }, {
        label: 'Operator 4',
        tasks: []
    }];
